export default __webpack_public_path__ + "static/media/loading.f4c4c873.svg";